import { ENV } from "./env";
const ENVDEV = {
  ...ENV,
  env: "PRODUCTION",
  chargebeeSite: "venuescanner",
};
export default ENVDEV;
